import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, LoadingState } from "@/components/shared";
import { SalesNav, usd } from "./common";

const COL_LABELS = {
  draft: "Draft", internal_review: "Internal Review", approved: "Approved", sent: "Sent",
  viewed: "Viewed", accepted: "Accepted", declined: "Declined", expired: "Expired",
  superseded: "Superseded", converted: "Converted",
};
const COL_ACCENT = {
  draft: "border-t-slate-400", internal_review: "border-t-amber-400", approved: "border-t-blue-400",
  sent: "border-t-blue-500", viewed: "border-t-violet-500", accepted: "border-t-emerald-500",
  declined: "border-t-rose-500", expired: "border-t-rose-400", superseded: "border-t-slate-300",
  converted: "border-t-emerald-600",
};

export default function EstimatePipeline() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/sales/estimates/pipeline").then((r) => setData(r.data)); }, []);

  return (
    <div data-testid="estimate-pipeline-page">
      <PageHeader title="Sales & Estimates" description="Estimate pipeline grouped by status." />
      <SalesNav />
      {!data ? <LoadingState label="Loading pipeline…" /> : (
        <div className="flex gap-4 overflow-x-auto tf-scroll pb-4">
          {data.columns.map((col) => (
            <div key={col} className={`min-w-[260px] w-[260px] shrink-0 bg-slate-50 rounded-xl border-t-4 ${COL_ACCENT[col]}`} data-testid={`pipeline-col-${col}`}>
              <div className="flex items-center justify-between px-3 py-2.5 border-b border-slate-200">
                <span className="text-sm font-semibold text-slate-700">{COL_LABELS[col]}</span>
                <span className="text-xs bg-white border border-slate-200 rounded-full px-2 py-0.5 text-slate-500">{data.grouped[col]?.length || 0}</span>
              </div>
              <div className="p-2 space-y-2 min-h-[80px]">
                {(data.grouped[col] || []).map((p) => (
                  <button key={p.id} onClick={() => navigate(`/sales/estimates/${p.id}`)} data-testid={`pipeline-card-${p.id}`}
                    className="w-full text-left bg-white border border-slate-200 rounded-lg p-3 hover:shadow-md hover:border-blue-200 transition-all">
                    <div className="flex items-center justify-between"><span className="text-sm font-medium text-slate-800 truncate">{p.client_name}</span></div>
                    <div className="text-xs text-slate-400 font-mono mt-0.5">{p.estimate_number}</div>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-sm font-semibold text-slate-700">{usd(p.total, p.currency)}</span>
                      <span className="text-[11px] text-slate-400">{p.assigned_user_name || "—"}</span>
                    </div>
                  </button>
                ))}
                {(data.grouped[col] || []).length === 0 && <div className="text-xs text-slate-300 text-center py-4">Empty</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
